var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.957,
    height: 11.957,
    viewBox: "0 0 11.957 11.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-info",
    "data-name": "Icon feather-info",
    transform: "translate(-2.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12112",
    "data-name": "Path 12112",
    d: "M13.957,8.479A5.479,5.479,0,1,1,8.479,3a5.479,5.479,0,0,1,5.479,5.479Z",
    transform: "translate(0 -3)",
    fill: "none",
    stroke: "#1c67f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12113",
    "data-name": "Path 12113",
    d: "M18,20.191V18",
    transform: "translate(-9.521 -12.521)",
    fill: "none",
    stroke: "#1c67f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12114",
    "data-name": "Path 12114",
    d: "M18,12h0",
    transform: "translate(-9.521 -8.713)",
    fill: "none",
    stroke: "#1c67f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0dd97670b0097412f537c79c8fc16f3a.svg";
export { ForwardRef as ReactComponent };